// extracted by mini-css-extract-plugin
export default {"root":"IconButtons_root__fbw8V","preloader":"IconButtons_preloader__91B0B","icon":"IconButtons_icon__OVH3+"};